import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = hash.replace('#', '');
    let cancelled = false;

    const scrollToAnchor = () => {
      const element = document.getElementById(id);
      if (!element) return false;
      element.scrollIntoView({ behavior: 'smooth' });
      return true;
    };

    if (scrollToAnchor()) return;

    const interval = window.setInterval(() => {
      if (cancelled) return;
      if (scrollToAnchor()) window.clearInterval(interval);
    }, 50);

    const timeout = window.setTimeout(() => {
      cancelled = true;
      window.clearInterval(interval);
    }, 3000);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
      window.clearTimeout(timeout);
    };
  }, [pathname, hash]);

  return null;
}
